import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SvgIcon from '../SvgIcon';

var DismissCircle = function DismissCircle(props) {
  return _jsxs(SvgIcon, __assign({}, props, {
    children: [_jsx("path", {
      d: "M8.56564 7.43451C8.25322 7.12209 7.74669 7.12209 7.43427 7.43451C7.12185 7.74693 7.12185 8.25346 7.43427 8.56588L10.8686 12.0002L7.43427 15.4345C7.12185 15.7469 7.12185 16.2535 7.43427 16.5659C7.74669 16.8783 8.25322 16.8783 8.56564 16.5659L12 13.1316L15.4343 16.5659C15.7467 16.8783 16.2532 16.8783 16.5656 16.5659C16.8781 16.2535 16.8781 15.7469 16.5656 15.4345L13.1313 12.0002L16.5656 8.56588C16.8781 8.25346 16.8781 7.74693 16.5656 7.43451C16.2532 7.12209 15.7467 7.12209 15.4343 7.43451L12 10.8688L8.56564 7.43451Z"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM22.4 12C22.4 17.7438 17.7438 22.4 12 22.4C6.25624 22.4 1.6 17.7438 1.6 12C1.6 6.25624 6.25624 1.6 12 1.6C17.7438 1.6 22.4 6.25624 22.4 12Z"
    })]
  }));
};

export default DismissCircle;